{
  "export.title": "Exportar",
  "export.preview": "Vista previa",
  "export.deploy": "Desplegar"
}
